// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import PerunMessage from "./PerunMessage";
import ChannelState from "./types/channelState";
import { MessageType, MessageTypeName } from "./messageTypes";
import ProposalID from "./types/poposalID";

@jsonObject
export default class ChannelProposal extends PerunMessage {
  @jsonMember(ProposalID) ID: ProposalID;
  @jsonMember(String) peerAddressEth: string;
  @jsonMember(String) peerAddressCC: string;
  @jsonMember(ChannelState) state: ChannelState;

  constructor(
    ID: ProposalID,
    peerAddressEth: string,
    peerAddressCC: string,
    state: ChannelState,
  ) {
    super();
    this.ID = ID;
    this.peerAddressEth = peerAddressEth;
    this.peerAddressCC = peerAddressCC;
    this.state = state;
  }

  messageType(): MessageType {
    return ChannelProposal;
  }

  messageTypeName(): MessageTypeName {
    return "ChannelProposal";
  }
}
